import { WHITE } from './common'
import {
  CHECKS,
  CHECK_BOX,
  HIRE_AT,
  HIRE_BTN,
  LIST_AT,
  LIST_BTN
} from './sceneHire'
import {
  ASK_AT,
  ASK_BTN,
  INVITE_AT,
  OPT_A,
  OPT_B,
  PICK_AT,
  PROFILE_BTN,
  TPL_AT,
  TPL_ROW
} from './sceneNeed'
import { MATCH_HOVER, TAP_POS, TAP_TIMES } from './scenePlay'

/**
 * Drehbuch „Aivy Morph“: eine Situation in 33,5 s auf 120-BPM-Raster. Das Team
 * braucht jemanden, HR nimmt eine Vorlage, Lena macht das Assessment in
 * wenigen Minuten, HR sieht das Match, wählt vor und stellt ein.
 */

export const DUR = 33.5

// Alles weiß wie im Dashboard: Karten mit Radius 12, Hinweise als Benachrichtigung
const note = (w) => ({ w, h: 72, r: 12, bg: WHITE })
const card = (w, h, r = 12) => ({ w, h, r, bg: WHITE })

export const STATES = [
  { t: 0, c: 'need', ...note(380) },
  { t: 1.5, c: 'ask', ...card(440, 212) },
  { t: ASK_AT, c: 'loader', w: 64, h: 64, r: 32, bg: WHITE },
  { t: 4.25, c: 'setup', ...card(500, 256) },
  { t: PICK_AT, c: 'template', ...card(500, 264) },
  { t: TPL_AT, c: 'profile', ...card(560, 360) },
  { t: INVITE_AT, c: 'invited', ...note(380) },
  { t: 12.5, c: 'play', ...card(360, 440, 28) },
  { t: 17, c: 'done', ...note(420) },
  { t: 18.5, c: 'match', ...card(560, 392) },
  { t: 23, c: 'list', ...card(560, 352) },
  { t: LIST_AT, c: 'interviews', ...note(420) },
  { t: 27.5, c: 'hire', ...card(460, 240) },
  { t: 30.25, c: 'welcome', ...note(400) },
  { t: 32, c: 'need', ...note(380) }
]

// Ruhepunkt des Cursors neben der Form
const rest = (w, h, dx = 60, dy = 46) => [w / 2 + dx, h / 2 + dy]

export const CURSOR = {
  start: rest(380, 72),
  keys: [
    [2, ...rest(440, 212)],
    [2.9, ...ASK_BTN],
    [3.9, ...rest(64, 64, 40, 30)],
    [4.8, ...rest(500, 256)],
    [5.25, ...OPT_A],
    [6, ...OPT_B],
    [6.9, ...rest(500, 264)],
    [7.7, ...TPL_ROW],
    [8.7, ...rest(560, 360)],
    [10.4, ...PROFILE_BTN],
    [11.4, ...rest(380, 72)],
    ...TAP_TIMES.map((tc, k) => [tc - 0.32, ...TAP_POS[k]]),
    [17.1, ...rest(420, 72)],
    [18.8, ...rest(560, 392)],
    [20.8, ...MATCH_HOVER],
    [22.7, ...rest(560, 392)],
    [23.6, ...CHECK_BOX(0)],
    [24.2, ...CHECK_BOX(1)],
    [24.7, ...CHECK_BOX(2)],
    [25.45, ...LIST_BTN],
    [26.4, ...rest(420, 72)],
    [28.05, ...HIRE_BTN],
    [30.3, ...rest(400, 72)],
    [32.2, ...rest(380, 72)]
  ],
  clicks: [
    ASK_AT,
    PICK_AT,
    TPL_AT,
    INVITE_AT,
    ...TAP_TIMES,
    ...CHECKS,
    LIST_AT,
    HIRE_AT
  ],
  holds: []
}

// Keine Dehnung in dieser Geschichte
export const STRETCH = null
